<template lang="html">
  <div class="slide" ref="root">
    <svg class="canvas" ref="scene" :viewBox="`0 0 ${canvasWidth} ${canvasHeight}`" xmlns="http://www.w3.org/2000/svg">
      <clipPath id="clipFrame">
        <rect x="0" y="0" :width="canvasWidth" :height="canvasHeight" />
      </clipPath>
      <rect id="Frame" x="0" y="0" :width="canvasWidth" :height="canvasHeight" />
      <g :transform-origin="`${canvasWidth/2} ${canvasHeight/2}`">
        <foreignObject x="0" y="0" :width="canvasWidth" :height="canvasHeight">
          <picture>
            <source :srcset="`${publicPath}scenes/haskell/BG-480w.jpg`" media="(max-width: 480px)">
            <source :srcset="`${publicPath}scenes/haskell/BG-768w.jpg`" media="(max-width: 768px)">
            <source :srcset="`${publicPath}scenes/haskell/BG-1280w.jpg`" media="(max-width: 1280px)">
            <source :srcset="`${publicPath}scenes/haskell/BG-1920w.jpg`" media="(max-width: 1920px)">
            <img :style="{width: `100%`, height: `auto`}" :src="`${publicPath}scenes/haskell/BG.jpg`" />
          </picture>
        </foreignObject>
      </g>
        <g class="leaves">
          <image
            :width="canvasWidth" :height="canvasHeight"
            :href="`${publicPath}scenes/haskell/F1-1000x720.png`"
            :xlink:href="`${publicPath}scenes/haskell/F1-1000x720.png`" />
          <image
            :width="canvasWidth" :height="canvasHeight"
            :href="`${publicPath}scenes/haskell/F2-1000x720.png`"
            :xlink:href="`${publicPath}scenes/haskell/F2-1000x720.png`" />
          <image
            :width="canvasWidth" :height="canvasHeight"
            :href="`${publicPath}scenes/haskell/F3-1000x720.png`"
            :xlink:href="`${publicPath}scenes/haskell/F3-1000x720.png`" />
        </g>
    </svg>
    <SceneDialogue
      ref="dialogue"
      :width=".33" :tx="1" :ty=".34">
      When he was old enough, Max chose to go to high school at the Haskell Institute in Lawrence, Kansas. He liked Lawrence. During the breaks, he stayed at school. He worked to earn enough spending money. When he was in school, he got good grades. So he got a position in the only all-Indian Cavalry unit at Fort Riley nearby.
    </SceneDialogue>
    <SceneAudio ref="scene-audio" :src="`${publicPath}scenes/haskell/audio-charlie-navajo.mp3`" />
  </div>
</template>

<script>
import SceneDialogue from "../SceneDialogue.vue"
import Template from "./Template.vue"
import {TimelineLite, TweenLite} from "gsap"

export default {
  data: () => ({
    publicPath: process.env.BASE_URL,
    canvasWidth: 1000,
    canvasHeight: 720,
  }),
  props: ["slide"],
  extends: Template,
  mounted() {
    const { root, scene } = this.$refs
    const d = root.querySelector(".content")
    // this.tl = new TimelineLite({paused: true})
    TweenLite.set(d, {opacity: 0})
    TweenLite.set(scene, {opacity: 0})
    this.tl.add(TweenLite.to(scene, 1, {opacity: 1}))
    this.tl.add(TweenLite.to(d, 0.5, {opacity: 1}))
  },
  methods: {
    enter() { this.tl.play() }
  },
  components: {
    SceneDialogue,
  },
}
</script>

<style lang="scss" scoped>
.clouds {
  animation: sky 40s linear infinite;
}
.leaves {
  image {
    animation: leaves 1s infinite;
    animation-timing-function: steps(0, end);
    &:nth-of-type(1) { animation-delay: 0s; }
    &:nth-of-type(2) { animation-delay: .25s; }
    &:nth-of-type(3) { animation-delay: .5s; }
  }
}
@keyframes sky {
  to { transform: translateX(0px); }
}
@keyframes leaves {
  0% { opacity: 1 }
  33% { opacity: 0 }
}
</style>
